export const FETCH_LIST_DELETED_TEMPLATE_TASK_FOR_PROJECT_PAGE_REQUEST = 'FETCH_LIST_DELETED_TEMPLATE_TASK_FOR_PROJECT_PAGE_REQUEST'
export const FETCH_LIST_DELETED_TEMPLATE_TASK_FOR_PROJECT_PAGE_SUCCESS = 'FETCH_LIST_DELETED_TEMPLATE_TASK_FOR_PROJECT_PAGE_SUCCESS'
export const FETCH_LIST_DELETED_TEMPLATE_TASK_FOR_PROJECT_PAGE_FALUIRE = 'FETCH_LIST_DELETED_TEMPLATE_TASK_FOR_PROJECT_PAGE_FALUIRE'
export const FETCH_SEARCH_TTEPMLATE='FETCH_SEARCH_TTEPMLATE'
